import moment from "moment";
import { useEffect, useState } from "react";

export interface FlightFromAiInfo {
  artist: server.dto.ArtistSmall
  travelAgency: string
  notes: string

  airline: server.dto.Airline
  flightDesignator: string

  departureLocal: moment.Moment
  departureAirport: server.dto.Airport
  departureTerminal: string

  arrivalLocal: moment.Moment
  arrivalAirport: server.dto.Airport
  arrivalTerminal: string
}

const mapFlightToState = (
  flight: server.dto.ExtractedFlight
): FlightFromAiInfo => ({
  artist: flight.artist,
  travelAgency: flight.travelAgency,
  notes: flight.notes,

  airline: flight.airline,
  flightDesignator: flight.flightDesignator,

  departureLocal: moment.utc(flight.dateTime.startDisplay),
  departureAirport: flight.departureAirport,
  departureTerminal: flight.departureTerminal,

  arrivalLocal: moment.utc(flight.dateTime.endDisplay),
  arrivalAirport: flight.arrivalAirport,
  arrivalTerminal: flight.arrivalTerminal,
});

export const useExtractorSessionDetail = (
  flight: server.dto.ExtractedFlight,
) => {
  const [state, setState] = useState<FlightFromAiInfo>(mapFlightToState(flight));


  useEffect(() => {
    setState(() => mapFlightToState(flight));
  }, [flight]);

  const onValueChanged = (key: string, value: any) => {
    if (key === "artist") {
      setState({ ...state, artist: value });
    } else if (key === "travelAgency") {
      setState({ ...state, travelAgency: value });
    } else if (key === "notes") {
      setState({ ...state, notes: value });
    } else if (key === "airline") {
      setState({ ...state, airline: value });
    } else if (key === "flightDesignator") {
      setState({ ...state, flightDesignator: value });
    } else if (key === "departureLocal") {
      const diff = value.diff(state.departureLocal, "minutes");
      const newArrivalLocal = state.arrivalLocal.clone().add(diff, "minutes");
      setState({
        ...state,
        departureLocal: value,
        arrivalLocal: newArrivalLocal,
      });
    } else if (key === "departureAirport") {
      setState({ ...state, departureAirport: value });
    } else if (key === "departureTerminal") {
      setState({ ...state, departureTerminal: value });
    } else if (key === "arrivalLocal") {
      setState({ ...state, arrivalLocal: value });
    } else if (key === "arrivalAirport") {
      setState({ ...state, arrivalAirport: value });
    } else if (key === "arrivalTerminal") {
      setState({ ...state, arrivalTerminal: value });
    } else {
      console.warn(`Unknown key ${key} in onValueChanged, value: ${value}`);
    }
  }

  const getUpdateExtractedFlightInstruction = (f: FlightFromAiInfo): server.dto.UpdateExtractedFlightInstruction => ({
    extractedFlightId: flight.extractedFlightId,
    artistId: f.artist.artistId,
    airlineId: f.airline?.airlineId || 0,
    arrivalAirportId: f.arrivalAirport.airportId,
    arrivalLocal: f.arrivalLocal.toDate(),
    arrivalTerminal: f.arrivalTerminal,
    departureAirportId: f.departureAirport.airportId,
    departureLocal: f.departureLocal.toDate(),
    departureTerminal: f.departureTerminal,
    flightDesignator: f.flightDesignator,
    notes: f.notes,
    travelAgency: f.travelAgency
  });

  return {
    state,
    onValueChanged,
    getUpdateExtractedFlightInstruction,
  }
}
